//-----------------
// is capped skill
//-----------------
export default function isCappedSkill(parm) {

  const cur_no_adjs = Number(parm.cur_no_adjs) || 0
  const max = Number(parm.max) || 0

  // console.log('cur_no_adjs = ', cur_no_adjs)
  // console.log('max = ', max)

  return cur_no_adjs >= max
}
